import React from "react";
import { BENEFITS } from "../data/content";
import Icon from "./Icon";
import "../styles/benefits.css";

function BenefitsList({ limit }) {
  const list = limit ? BENEFITS.slice(0, limit) : BENEFITS;
  return (
    <ul className="benefits-list">
      {list.map((benefit) => (
        <li className="benefits-item" key={benefit}>
          <span className="benefits-check" aria-hidden="true">
            <Icon name="check" size={13} />
          </span>
          <span>{benefit}</span>
        </li>
      ))}
    </ul>
  );
}

export default BenefitsList;
